<template>
    <div class="blank">
        <div v-if="isDd" class="">
            <div class="help-header">
                <ul>
                    <li>
                        <a href="https://im2.zhongan.io/zaim/?accessId=1585100918028&tenantID=1557976036000381&color=yellow&themeID=DD001&subject=点点业务&biz=APP">
                            <i></i>
                            <p>在线客服</p>
                        </a>
                    </li>
                    <li>
                        <a @click="kfPhoneHandle" ref="kfPhone">
                            <i></i>
                            <p>客服热线</p>
                        </a>
                    </li>
                    <li>
                        <a href="zldd://feedBack">
                            <i></i>
                            <p>意见反馈</p>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="h-title">常见问题分类</div>
        </div>
        <div class="help-list">
            <group gutter="0" type="hint">
                <cell v-for="(item, index) in list" :key="index" :title="item.categoryName" @click="nextRoute(index)" class="help">
                    <div slot="right">
                        <img class="icon" src="../assets/images/link.png" height="12" width="7" alt="">
                    </div>
                </cell>
            </group>
        </div>
        <div v-show="isAlert" class="alert-def-ui">
            <div class="alert-box">
                <div class="alert-content">
                    拨打点点客服热线：4000666122，服务时间：周一到周日 9:00-18:00。
                </div>
                <div @click="alertBtnHandle" class="alert-btn">确定</div>
            </div>
        </div>
        <loading v-show="isLoading"></loading>
    </div>
</template>
<script>
    import {
        Group,
        Cell
    } from 'fiui'
    // import { help } from '../utils/faq.js'
    import {ddcms} from '../api/axios';
    import storage from '../utils/storage'
    import Loading from '../components/loading';
    export default {
        data () {
            return {
                list: [],
                isDd:false,
                isLoading:false,
                isAlert:false
            }
        },
        watch:{
        },
        components: {
            Group,
            Cell,
            Loading
        },
        created () {
            //..
            this.isLoading=true;
            ddcms({
                id: 'helpCenterAPI.queryHelpCenterCategoryList',
                param: {
                    status:'1000'
                }
            }).then((res) => {
                if (res.status == 200) {
                    this.isLoading=false;
                    if (res.data.code == "1") {
                        let dataList = res.data.data.data
                        console.log(dataList,'标题分类');
                        let categoryList = []
                        dataList.forEach((e) => {
                            if(e.status==1000){
                                categoryList.push({
                                    categoryName:e.categoryName,
                                    categoryId:e.id
                                })
                            }
                        })
                        this.list=categoryList;
                    }else{
                        alert('查询接口失败')
                    }
                }
            }).catch((error) => {
                this.isLoading = false
                alert('请求失败')
            })
        },
        beforeRouteEnter (to, from, next) {
            document.title = '帮助中心'
            next()
        },
        mounted(){
            if(this.isDianDian()){
                this.isDd=true
            }else{
                this.isDd=false
            }
        },
        methods: {
            nextRoute (index) {
                window._helpIndex = index
                storage.set({'nowCategory':this.list[index]})
                this.$router.push('help')
            },
            isDianDian(){
                var u=(window.navigator.userAgent).toLocaleLowerCase()
                if(u.indexOf('diandian')>-1){
                    return true
                }else{
                    return false
                }
            },
            alertBtnHandle(){
                this.isAlert=false
                window.location.href = 'tel:4000666122'
            },
            kfPhoneHandle(){
                this.isAlert=true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// helpcenter.vue?6b81a0f3